function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD-Copy-2",
  transform: "translate(-730.000000, -308.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(333.000000, 191.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "exito",
  transform: "translate(397.000000, 117.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#98DD00",
  fillRule: "nonzero",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "29 13 17.3076923 26 10 20.2222222"
})))));
function SvgCheckIconGreenSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "exito") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconGreenSm);
export default __webpack_public_path__ + "static/media/check-icon--green--sm.2689592d6d9a129756b67c8955b16f5c.svg";
export { ForwardRef as ReactComponent };